export class DispatchDataPayload {
    dataInSap!: string;
    sapWo!: string;
    analystEntry!: string;
    dispatchEntry!: string;
    dispatchFirstName!: string;
    dispatchLastName!: string;
    StatusUpdateNotes!: string;
    dispatchTechId!: string;
  }